<template>
  <div
    class="flex flex-grow items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-md w-full space-y-8">
      <div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
          Forgot Password
        </h2>
        <p class="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>
      <form class="mt-8 space-y-6" @submit.prevent="handleForgotPassword">
        <div v-if="error" class="rounded-md bg-red-50 dark:bg-red-900/20 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <i class="pi pi-exclamation-circle text-red-400"></i>
            </div>
            <div class="ml-3">
              <p class="text-sm font-medium text-red-800 dark:text-red-200">
                {{ error }}
              </p>
            </div>
          </div>
        </div>

        <div v-if="success" class="rounded-md bg-green-50 dark:bg-green-900/20 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <i class="pi pi-check-circle text-green-400"></i>
            </div>
            <div class="ml-3">
              <p class="text-sm font-medium text-green-800 dark:text-green-200">
                {{ success }}
              </p>
            </div>
          </div>
        </div>

        <div>
          <label for="email" class="sr-only">Email address</label>
          <input
            id="email"
            v-model="form.email"
            name="email"
            type="email"
            autocomplete="email"
            required
            class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 placeholder-gray-500 dark:placeholder-gray-400 text-gray-900 dark:text-white bg-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
            placeholder="Email address"
          />
        </div>

        <div>
          <Button
            type="submit"
            :disabled="loading"
            :label="loading ? 'Sending...' : 'Send Reset Link'"
            severity="primary"
            :loading="loading"
            class="w-full"
          />
        </div>

        <div class="text-center">
          <router-link
            to="/login"
            class="font-medium text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300"
          >
            Back to login
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import api from "@/services/api";
import Button from "primevue/button";

export default {
  name: "ForgotPassword",
  components: {
    Button
  },
  setup() {
    const form = ref({
      email: ""
    });
    const error = ref("");
    const success = ref("");
    const loading = ref(false);

    const handleForgotPassword = async () => {
      try {
        loading.value = true;
        error.value = "";
        success.value = "";

        const response = await api.post("/api/auth/forgot-password", {
          email: form.value.email
        });

        if (response.data.success) {
          success.value =
            response.data.message || "Password reset link has been sent to your email.";
        } else {
          error.value = response.data.message || "Failed to send password reset email";
        }
      } catch (err) {
        console.error("Forgot password error:", err);
        // The backend always returns success to prevent enumeration,
        // but handle any network errors
        if (err.response?.data?.message) {
          success.value = err.response.data.message;
        } else {
          error.value = "An error occurred. Please try again.";
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      error,
      success,
      loading,
      handleForgotPassword
    };
  }
};
</script>
